import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { VolumesContextProvider } from "./context/volumes.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { volumes } = usePaintConfiguratorContext();
    return (
        <div
            className={cn(
                "tw:w-full tw:grid tw:grid-cols-2 tw:md:grid-cols-3 tw:md:gap-6 tw:gap-4"
            )}
        >
            <VolumesContextProvider volumes={volumes}>
                {children}
            </VolumesContextProvider>
        </div>
    );
};

export { Base };
